import React from 'react';
import Rectangle from '@splunk/dashboard-visualizations/Rectangle';

export default () => <Rectangle options={{ strokeLinejoin: 'bevel', strokeWidth: 10 }} />;
